import { Component } from "react";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import { Spinner } from "../../Components/Spinner/Spinner";
import { withRouter } from "react-router-dom";
import { closeModel } from "../../assets/Js/closeModel";

export default withRouter(
class ConnectWithStripeButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isStripeLoading: false,
    };
  }

  connectWithStripe = async () => {
    if (this.props.redirectToConnectPage) {
      closeModel(this.props.modalId);
      this.props.history.push("/dashboard/connect");
    }else{ 
    let url = `${projectSettings.baseUrl}/subscriptions/connect`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;
    let response = "";

    if (response === "") {
      this.setState({ isStripeLoading: true });
    }

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      console.log("redirect url of stripe:", response);
      // resetting values
      this.setState({ isStripeLoading: false });
      if (response.type === "error") {
        apiResponseToast(
          response.status,
          "connectwithstripe",
          response.data.message
        );
      } else if (response.type === "success") {
        //  redirection
        window.open(response.data.url, "_blank");
      }
    }}
  };

  render() {
    return (
      <button
        className="basicFatBtnStyle primaryBtn size200-35"
        disabled={this.isStripeLoading}
        onClick={this.connectWithStripe}
      >
        {this.state.isStripeLoading ? (
          <div>
            <Spinner />
          </div>
        ) : (
          <span>Connect With Stripe</span>
        )}
      </button>
    );
  }
});
